<template>
	<div class="refund">
		<div class="crumbs">
		    <el-breadcrumb separator=">">
		      <!--<el-breadcrumb-item :to="{ path: '/' }">当前位置</el-breadcrumb-item>-->
		      <span style="float: left;font-size: 100%;font-weight: 700;">当前位置&nbsp;:&nbsp;</span>
			  <el-breadcrumb-item>财务管理</el-breadcrumb-item>
			  <el-breadcrumb-item>广告主退款申请</el-breadcrumb-item>
			</el-breadcrumb> 
		</div>
		<!--筛选条件部分-->
		<div class="filterBox">
			<ul>
				<li>
					<label>广告主ID:</label>
					<el-select
						style="width:220px"
						class="user-id"
					    v-model="userId"
					    clearable
					    filterable
					    remote
					    reserve-keyword
					    collapse-tags
					    placeholder="请输入关键词"
					    :remote-method="remoteMethod"
					    :loading="inploading">
					    <el-option
					      style="width:220px"
					      v-for="item in options4"
					      :key="item.id"
					      :label="item.id"
					      :value="item.id">
					      <span >[{{ item.id }}]</span>
        				  <span >{{ item.name }}</span>
					    </el-option>
					</el-select>
				</li>
				<li>
					<label>销售:</label>
					<el-select v-model="sell"  placeholder="请选择">
					    <el-option
					      v-for="item in sellers"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
				  </el-select>
				</li>
				<li>
					<label>广告运营:</label>
					<el-select v-model="operation"  placeholder="请选择">
					    <el-option
					      v-for="item in operationArr"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
				  	</el-select>
				</li>
				<li>
					<label>公司名称:</label>
					<el-input v-model="companyName" clearable  placeholder=""></el-input>
				</li>
				
				
				<li>
					<label>审核状态:</label>
					<el-select v-model="status"   placeholder="全部状态">
					    <el-option
					      v-for="item in statusArr"
					      :key="item.value"
					      :label="item.label"
					      :value="item.value">
					    </el-option>
				  	</el-select>
				</li>
				<li>
					<label>广告主身份:</label>
					<el-select v-model="identity"  placeholder="请选择">
					    <el-option
					      v-for="item in identityArr"
					      :key="item.value"
					      :label="item.label"
					      :value="item.value">
					    </el-option>
				  	</el-select>
				</li>
				<li>
					<label>添加时间:</label>
					 <el-date-picker class = "timepicker" v-model="datetime"   value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				</li>
				<input placeholder="结束日期" name="" class="el-range-input" style="display: none;">
				<li class="refundbtn">
					 <el-button type="primary" @click="searchrefundList">搜索</el-button>
					 <el-button type="primary" @click="rechargeExport">导出</el-button>
				</li>
			</ul>
		</div>
		<!--数据切换按钮-->
		<div class="changedata">
			<span class="iconfont el-icon-shuju touxiang"></span>
			<span class="pronum">退款申请(共{{totalCount}}条)</span>
		</div>
		<!--表格部分开始-->
		<div>
			<template>
			    <el-table
			      v-loading="loading"
			      :data="tableData"
			      style="width: 100%">
			      <el-table-column min-width="100" prop="Title" label="审核操作" align="center">
			      	  <template slot-scope="scope">
			      	  		<span href="" class="operate" :class="{ready:scope.row.Status != 0}" @click="showPassDialog(scope.row)">通过</span><br />
			      	  		<span href="" class="operate" :class="{ready:scope.row.Status != 0}" @click="reject(scope.row)">拒绝</span><br />
			      	  </template>
			      </el-table-column>
			      <el-table-column label="审核状态" min-width="90" align="center">
			      		<template slot-scope="scope">{{scope.row.Status | statusMethod}}</template>
			      </el-table-column>
			      <el-table-column min-width="100" label="广告主身份" align="center">
			      		<template slot-scope="scope">{{scope.row.UserSource | UserSourceMethod}}</template>
			      </el-table-column>
			      <el-table-column min-width="100" prop="UserId" label="广告主ID" align="center"></el-table-column>
			      <el-table-column min-width="100"prop="CompanyName" label="公司名称" align="center"></el-table-column>
			      <el-table-column min-width="90" prop="AdOperatorName" label="广告运营" align="center"></el-table-column>
			      <el-table-column prop="SalesManName" label="销售" align="center"></el-table-column>
			      <el-table-column min-width="120" label="账户充值余额" align="center">
			      		<template slot-scope="scope">{{scope.row.RechargeAmount | tofixed2}}</template>
			      </el-table-column>
			      <el-table-column min-width="120" label="账户返点余额" align="center">
			      		<template slot-scope="scope">{{scope.row.RebateAmount | tofixed2}}</template>
			      </el-table-column>
			      <el-table-column min-width="120" label="退款充值金额" align="center">
			      		<template slot-scope="scope">{{scope.row.ReFundAmount | tofixed2}}</template>
			      </el-table-column>
			      <el-table-column min-width="120" label="退款返点金额" align="center">
			      		<template slot-scope="scope">{{scope.row.RebateAmount | tofixed2}}</template>
			      </el-table-column>
			      <el-table-column min-width="180" label="添加时间" align="center">
			      		<template slot-scope="scope">{{scope.row.AddDate | tableDate}}</template>
			      </el-table-column>
			      <el-table-column min-width="110" prop="ReFundDateTime" label="退款时间" align="center">
			      		<template slot-scope="scope">{{scope.row.ReFundDateTime | tableDate(scope.row)}}</template>
			      </el-table-column>
			      <el-table-column prop="Remark" label="备注" align="center"></el-table-column>
			    </el-table>
			</template>
			<div class="pagination"  align="center">
				<el-pagination
				  @current-change="handleCurrentChange"
		          :current-page="currentPage"
		          :page-size="15"
				  background
				  layout="prev, pager, next"
				  :total="totalCount">
				</el-pagination>
			</div>
		</div>
		<!--审核弹窗-->
		<div class="passdialog">
	    	<el-dialog
			  title="审核退款申请"
			  top="30vh"
			  :visible.sync="passDialog"
			  width="30%"
			  min-width="350"
			  >
			  <ul class="editul">
			  	<li>
			  		<label>广告主ID:</label>
			  		<a>{{adverid}}</a>
			  		<!--<el-input  size="small" placeholder="请输入内容" v-model="userId" :disabled="true"> </el-input>-->
			  	</li>
			  	<li>
			  		<label>公司名称:</label>
			  		<a>{{advercompname}}</a>
			  		<!--<el-input type="number"  size="small" placeholder="请输入内容" v-model="companyName" :disabled="true"> </el-input>-->
			  	</li>
			  	<li>
			  		<label>退款金额:</label>
			  		<a>{{returnmonry}}</a>
			  		<!--<el-input  size="small" placeholder="请输入内容" v-model="returnmonry" > </el-input>-->
			  	</li>
			  	<li>
			  		<label>退款时间:</label>
			  		<el-date-picker
				      v-model="returntime"
				      type="date"
				      placeholder="选择日期">
				    </el-date-picker>
			  	</li>
			  	<input placeholder="结束日期" name="" class="el-range-input" style="display: none;">
			  </ul>
			  <div class="passbtn">
			  	 <el-button size="mini" @click="passDialog = false" >取消</el-button>
			  	 <el-button size="mini" type="primary" @click="refundPass">确定</el-button>
			  </div>
			</el-dialog>
	    </div>
	</div>
</template>

<script>
	import {pass} from 'api/rechargeWithRefund'  //通过驳回接口
	import {GetSalesman} from 'api/rechargeWithRefund'     //获取销售人接口
	import {GetUserAdOperatorUser} from 'api/rechargeWithRefund'     //获取运营列表接口
	import {refundList} from 'api/rechargeWithRefund'      //退款申请接口
	import {refundPass} from 'api/rechargeWithRefund' 		//通过驳回接口
	import {refundExport} from 'api/rechargeWithRefund'     //导出接口
	import {GetUser} from "api/advertiser";
	export default {
    	data() {
	      return {
	      	list:[],
	      	inploading:false,    //id加载中
	      	options4:[],		 //id的数组
	      	loading:true,   //控制加载中
	      	tableData:[],   //表格数据
	      	userId:"",      //广告主ID
	      	companyName:"", //公司名称
	      	sell:"",       //销售人
	      	sellers:[	    //销售人数组
	      		
	      	],
	      	operation:"",   //广告运营
	      	operationArr:[  //广告运营数组
	      		
	      	],
	      	datetime:[],     //时间
	      	status:-2,   //审核状态
	      	statusArr:[   //审核状态数组
	      		{
	      			value:-2,
	      			label:"全部状态"
	      		},
	      		{
	      			value:-1,
	      			label:"已拒绝"
	      		},{
	      			value:0,
	      			label:"审核中"
	      		},
	      		{
	      			value:1,
	      			label:"已通过"
	      		}
	      		
	      	], 
	      	identity:-1,   //广告主身份
	      	identityArr:[   //广告主身份数组
	      		{
	      	      value: -1,
		          label: '全部'
	      		},
	      		{
		          value: 0,
		          label: '直客'
		        }, 
		        {
		          value: 1,
		          label: '代理商'
		        }
	      	],
	      	passDialog:false,  //审核通过弹窗
	      	adverid:"",        //弹窗中广告主id
	      	advercompname:"",  //弹窗中公司名称
	      	returnmonry:"",   //退款金额
	      	returntime:"",    //实际退款时间
	      	currentPage:1,    //当前页数
	      	totalCount:null,  //数据总条数
	      	BusinessId:"",    //业务id
	      	
	      	
	      }
	    },
		methods:{
			remoteMethod(query) {
		        if (query !== '') {
		          this.inploading = true;
		          GetUser({
				        name: query, userType: 1 
				  }).then(res => {
				  		this.inploading = false;
						this.list = res.list.map(item => {
					        return { value: item, label: item };
					    });
				     	this.options4 = res.list
				  })
 				  
		        } else {
		          this.options4 = [];
		        }
	        },
			rechargeExport(){     //导出数据
				if(this.datetime == null){
					this.datetime = ""
				}
              	window.location.href="/IadFinanceReFun/Export?UserId="+this.userId + "&BeginDate=" + (this.datetime[0] || this.time) + "&EndDate=" + (this.datetime[1] || this.time) + "&CompanyName=" + this.companyName + "&SalesMan=" + this.sell+ "&AdOperatorId=" + this.operation + "&Status=" + this.status+ "&UserSource=" + this.identity;
			},
			reject(rows){
				if(rows.Status == -1 || rows.Status == 1){     //证明是已经通过货已经拒绝的，就不在网下执行
					this.open3("只有审核中状态的充值申请才可以审核或驳回")
					return 
				}
				refundPass({
					BusinessId:rows.BusinessId,
					Status:-1,
					ReFundDateTime:this.returntime
				}).then(res=>{
					console.log(res);
					this.passDialog = false; //显示审核通过弹窗
					this.$message({
			          message: '拒绝成功',
			          type: 'success'
			        });
			        this.refundList();      //获取退款列表
				})
			},
			refundPass(){    //退款通过接口
				if(this.returntime == ""){
					this.open3("请选择退款时间");
					return false;
				};
				refundPass({
					BusinessId:this.BusinessId,
					Status:1,
					ReFundDateTime:this.returntime
				}).then(res=>{
					console.log(res);
					this.passDialog = false; //显示审核通过弹窗
					this.$message({
			          message: '退款成功',
			          type: 'success'
			        });
			        this.refundList();      //获取退款列表
				})
			},
			handleCurrentChange(val){    //选定第几页
                    this.currentPage = val;
                    this.refundList()
            }, 
			showPassDialog(rows){
				if(rows.Status == -1 || rows.Status == 1){     //证明是已经通过货已经拒绝的，就不在网下执行
					this.open3("只有审核中状态的充值申请才可以审核活驳回")
					return 
				}
				this.BusinessId = rows.BusinessId;   //业务主键id
				this.adverid = rows.UserId;
				this.advercompname = rows.CompanyName;
				this.returnmonry = rows.ReFundAmount;
				this.returntime = "";   //先把时间清掉
				this.passDialog = true; //显示审核通过弹窗
				
			},
			open3(mes){     //顶部提示
		        this.$message({
		          message: mes,
		          type: 'warning'
		        });
		    },
		    GetSalesman(){		//获取销售人列表
		    	GetSalesman().then(res=>{
		    		this.sellers = res.list;
		    		this.sellers.unshift(
		    			{
		    				id:"",
		    				name:"全部销售"
		    			}
		    		)
		    	})
		    },
		    GetUserAdOperatorUser(){		//获取运营列表接口
		    	GetUserAdOperatorUser().then(res=>{
		    		console.log(res);
		    		this.operationArr = res.list;
		    		this.operationArr.unshift(
		    			{
		    				id:"",
		    				name:"全部运营"
		    			}
		    		)
		    	})
		    },
		    refundList(){
		    	if(this.datetime == null){
		    		this.datetime = []
		    	}
		    	if(this.identity == ""){
		    		this.identity == -1
		    	}
		    	refundList({
		    		UserId:this.userId,
		    		SalesMan:this.sell,
		    		AdOperatorId:this.operation,
		    		BeginDate:this.datetime[0] || "",
		    		EndDate:this.datetime[1] || "",
		    		CompanyName:this.companyName,
		    		Status:this.status,
		    		UserSource:this.identity,
		    		PageIndex:this.currentPage
		    	}).then(res=>{
		    		this.loading = false;
		    		this.totalCount = res.TotalNum;
		    		this.tableData = res.Items
		    	})
		    },
		    searchrefundList(){
		    	if(this.datetime == null){
		    		this.datetime = []
		    	}if(this.identity == ""){
		    		this.identity == -1
		    	}
		    	this.currentPage = 1
		    	refundList({
		    		UserId:this.userId,
		    		SalesMan:this.sell,
		    		AdOperatorId:this.operation,
		    		BeginDate:this.datetime[0] || "",
		    		EndDate:this.datetime[1] || "",
		    		CompanyName:this.companyName,
		    		Status:this.status,
		    		UserSource:this.identity,
		    		PageIndex:this.currentPage
		    	}).then(res=>{
		    		this.loading = false;
		    		this.totalCount = res.TotalNum;
		    		this.tableData = res.Items
		    	})
		    },
		    initialTime(){
		    	var myDate = new Date();;
				var thisyear = myDate.getFullYear();
				var thismonth = myDate.getMonth()+1;
				var day = myDate.getDate();
				if (thismonth < 10) {
				    thismonth = "0" + thismonth;
				}
				if (day < 10) {
				    day = "0" + day;
				}
				var newTime = thisyear+"-"+thismonth+"-01";      //当月月初日期
				var nowDate = thisyear + "-" + thismonth + "-" + day;  //当天日期
				this.datetime = [newTime,nowDate]
		    }
			
		},
		created () {
			this.GetSalesman();     //获取销售人列表
			this.GetUserAdOperatorUser();   //获取运营列表
			this.initialTime();     //将筛选条件中的  日期选择框赋值
			this.refundList();      //获取退款列表
			
		},
		filters:{
			tableDate(date,x) {  //过滤日期
				if(x){
					if(x.Status == 0){
						return ""
					}
				}
		        if (date) {
		          let timeSpan = date.replace(/(\/Date)|\/|\(|\)|\//ig, '');
		          let dates = new Date(parseInt(timeSpan));
		          let year = dates.getFullYear()
		          let month = dates.getMonth() + 1 > 9 ? dates.getMonth() + 1 : '0' + (dates.getMonth() + 1);
		          let day = dates.getDate() > 9 ? dates.getDate() : '0' + dates.getDate();
		          let hours = dates.getHours() > 9 ? dates.getHours() : '0' + dates.getHours();
		          let minutes = dates.getMinutes() > 9 ? dates.getMinutes() : '0' + dates.getMinutes();
		          let seconds = dates.getSeconds() > 9 ? dates.getSeconds() : '0' + dates.getSeconds();
		          if(x){
		          		return year + '-' + month + '-' + day 
		          }else{
		          		return year + '-' + month + '-' + day + " " + hours + ":" + minutes + ":" + seconds
		          }
		          
		        } else {
		          return '';
		        }
		    },
		    statusMethod(status){   // 状态转换
		      	if(status == 0){
		      		return "审核中"
		      	}
		      	if(status == 1){
		      		return "已通过"
		      	}
		      	if(status == -1){
		      		return "已拒绝"
		      	}
		    },
		    UserSourceMethod(users){
		    	if(users == 0){
		    		return "直客"
		    	}
		    	if(users == 1){
		    		return "代理"
		    	}
		    	if(users == 2){
		    		return "子账户"
		    	}
		    }
		}
		
	}
</script>

<style lang="scss">
	.refund{
		padding: 0 15px;
	}
	.refund .ready{
		color: #A8A297;
	}
	.refund .el-dialog{
		min-width: 400px;
	}
	/*顶部面包屑*/
	.refund .crumbs{
    	margin-top: 10px; padding: 10px 10px 10px 8px; border-left: 2px solid #bbb; background: #f5f5f5;
    }
    /*筛选部分样式*/
   .filterBox{
   		width: 100%;
   		border: 1px solid #f5f5f5;
   		margin-top: 20px;
		padding-top: 30px;
   }
   .filterBox ul:after {
	    content: '';
	    display: block;
	    clear: both;
	}
   .filterBox ul li{
   		label{
   			display: inline-block;
   			width: 85px;
   			text-align:right ;
   		}
   		float: left;
   		/*width: 20%;*/
   		/*max-width: 250px;*/
   		margin-right: 20px;
   		height: 50px;
   		padding-left: 10px;
   		.el-select {
	          &.user-id {
	          	.el-input__inner {
	          		width: 220px;
	          	}
	          	.el-input__suffix{
	          		left: 150%;
	          	}
	          }
	        }
   		
   }
   .filterBox .el-input{
   		width: 130px;
   }
   
   .filterBox ul li:nth-child(5){
   	    /*width: 350px;*/
   	    /*max-width: 350px;*/
   		content: '';
	    display: block;
	    /*clear: both;*/
   }
   .filterBox ul li:nth-child(7){
   	    width: 350px;
   	    max-width: 350px;
   }
   .filterBox ul li:nth-child(7) .timepicker {
   		width: 240px;
   }
   .refundbtn button{
   		height: 34px;
		line-height: 0;
   }
   
   
   /*表格部分*/
  .changedata{
  		margin-top: 10px;
  		margin-bottom: 10px;
  		.iconfont{
  			color: #BBBBBB;
  			position: relative;
  		}
  		.pronum{
  			margin-right: 10px;
  		}
  		button{
  			line-height: 1px;
  			padding-left:10px;
  			padding-right: 10px;
  			font-size: 12px;
  			color: black;
  		}
  	}
  	.operate{
		color:rgb(114, 172, 227) ;
		font-size: 14px;
		cursor: pointer;
	}
  	
  	/*弹出样式部分*/ 
	.editul li{
		margin-bottom: 10px;
		text-align: center;
		label{
			display: inline-block;
			width: 120px;
			text-align: right;
		}
	}
	/*分页样式*/
  	.refund .pagination{
  		margin-top: 20px;
		display: block !important;
	}
</style>
<style>
	.editul li a{
		display: inline-block;
		width: 50%;
		margin-left: 10px;
		text-align: left;
	}
	.editul .el-input{
		width: 50% !important;
		margin-left: 10px;
	}
	.passbtn{
		text-align: center;
		margin-top: 30px;
	}
	.editul li .el-input__icon{
		line-height: 35px;
	}
	.refund .el-range-separator{
		width: 10% !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/financial-management/refund.vue